import { Box, type BoxProps, Space } from '@stenajs-webui/core';
import type { FC } from 'react';

export const PopoverBody: FC<BoxProps> = ({ children, ...props }) => (
  <Box indent={3} {...props}>
    {children}
    <Space num={2} />
  </Box>
);
